import { render, staticRenderFns } from "./PagedTable.vue?vue&type=template&id=68ee0ec7&scoped=true"
import script from "./PagedTable.vue?vue&type=script&lang=js"
export * from "./PagedTable.vue?vue&type=script&lang=js"
import style0 from "./PagedTable.vue?vue&type=style&index=0&id=68ee0ec7&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ee0ec7",
  null
  
)

export default component.exports